export default __webpack_public_path__ + "static/media/Bear-Cake.92f10b00.jpg";